<template>
  <div class="factory-card">
    <div class="img-wrapper" ref="carouselWrapper">
      <carousel navigationEnabled ref="carousel" v-if="pictures && pictures.length" class="my-carousel" :perPage="1">
        <slide v-for="(pic, index) in pictures" class="my-slide" :key="index">
          <img :src="pic" class="slider-pics" @load="adjustImageStyle($event.target)">
        </slide>
      </carousel>
      <img v-else src="../assets/images/picture_default.png" alt="">
    </div>
    <div class="content-wrapper">
      <div class="title">
        <img v-if="logo && logo.length != 0" class="title-logo" :src="logo" alt="なし">
        <img v-else class="title-logo" src="../assets/images/factory_default.png" alt="なし">

        <div class="title-text">
          <p class="name">{{ (name && name.length != 0) ? name : '拠点名'}}</p>
          <div class="sub-content">
            <div class="tag">
              <img src="../assets/images/location_logo.png" alt="">
              <p>{{ (location && location.length != 0) ? location : '---' }}</p>
            </div>
            <div class="tag">
              <img src="../assets/images/website_logo.png" alt="">
              <p>{{ (website && website.length != 0) ? website : '---' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="detailed-content">
        <p>対応可能な加工</p>
        <p>{{ (service && service.length != 0) ? service : '-' }}</p>
      </div>
      <div class="detailed-content one-rem-margin">
        <p>材料</p>
        <p>{{ (material && material.length != 0) ? material : '-' }}</p>
      </div>
      <div class="detailed-content one-rem-margin">
        <p>自己紹介</p>
        <p class="pre-wrap">{{ (introduction && introduction.length != 0) ? introduction : '-' }}</p>
      </div>
    </div>
    <div class="button-section">
      <button @click.prevent.stop="$emit('editCard')">編集する</button>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default  {
  name: "FactoryCard",
  components: {
    Carousel,
    Slide
  },

  props: {
    name: '',
    pictures: Array,
    logo: '',
    location: '',
    website: '',
    service: '',
    material: '',
    introduction: '',
  },
  
  watch: {
    
  },
  mounted () {
    // this.$nextTick(() => {
      // document.querySelector('.my-carousel').click();
    // });
  },

  methods: {
    adjustImageStyle(image) {
      const containerAspectRatio = 330 / 200;
      const imageAspectRatio = image.naturalWidth / image.naturalHeight;

      if (imageAspectRatio > containerAspectRatio) {
        image.style.height = "200px";
        image.style.width = "auto";
      } else {
        image.style.width = "330px";
        image.style.height = "auto";
      }
    },
    
  },
}
</script>

<style lang="scss" scoped>
  .factory-card {
    position: relative;
    width: 330px;
    color: #000;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .img-wrapper {
      width: 100%;
      height: 200px;
      overflow: hidden;
      position: relative;

      .my-carousel {
        width: 100%;

        .my-slide {
          display: flex;
          justify-content: center;
          align-items: flex-start;

          img {
            width: 100%;
            max-width: 100%; 
            max-height: 100%;
          }
        }
      }

      .my-carousel >>> .VueCarousel-navigation {
        color: #fff; 
        background: transparent;
        border: none;
        font-size: 24px;
        cursor: pointer;
      }

      .my-carousel >>> .VueCarousel-navigation-next {
        transform: translateY(-70px) scale(0.7);
        background-color: rgba(255, 255, 255, .7);
        width: 50px;
        height: 50px;
        border-radius: 99em;
      }

      .my-carousel >>> .VueCarousel-navigation-prev {
        transform: translateY(-70px) scale(0.7);
        background-color: rgba(255, 255, 255, .7);
        width: 50px;
        height: 50px;
        border-radius: 99em;
      }

      img {
        width: 100%;
      }
    }

    .content-wrapper {
      padding: 1rem;

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 1.5rem;

        .title-logo {
          width: 50px;
          height: 50px;
          border-radius: 99em;
        }

        .title-text {
          margin-left: 1rem;

          .name {
            font-size: 24px;
          }

          .sub-content {
            display: flex;
            margin-top: .5rem;

            .tag {
              display: flex;
              align-items: center;

              img {
                width: 15px;
                height: 15px;
                margin-right: 3px;
              }
            }

            .tag:nth-child(2) {
              margin-left: .5rem;
            }
          }
        }
      }

      .detailed-content {
        display: flex;
        width: 100%;

        p {
          line-height: 1.5;
        }

        p:nth-child(1) {
          width: 30%;
        }

        p:nth-child(2) {
          width: 70%;
        }
      }

      .one-rem-margin {
        margin-top: 1rem;
      }

      .intro-block {
        width: 100%;
        height: 5rem;
        background-color: #EEEEEE;
        border: none;
        border-radius: 10px;
        appearance: none;
        padding: .5rem;
      }
    }

    .button-section {
      width: 100%;
      padding: 1rem;
      display: flex;
      justify-content: end;
      button {
        width: fit-content;
        height: 45px;
        padding: 0 15px;
        font-size: 14px;
        line-height: 1;
        background-color: #eeeeee;
        border-radius: 99em;
      }
    }

    .pre-wrap {
      white-space: pre-wrap;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/FactoryCard.vue